import { render } from "./DietForm.vue?vue&type=template&id=84620ec4"
import script from "./DietForm.vue?vue&type=script&lang=js"
export * from "./DietForm.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__